import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const BerichtAuswertungen: React.FC = () => {
    const styles = useStyles();

    const handleOpenLink = () => {
        // Link to old FHelix system
        window.open('https://fhelix.fh-krems.ac.at/studienverwaltung/bewerber/SitePages/Auswertungen.aspx', '_blank');
    };

    return (
        <div className={styles.container}>
            <h1>Berichte/Auswertungen</h1>
            <p>Zugriff auf Berichte und Auswertungen im alten FHelix System</p>
            <button onClick={handleOpenLink}>Zum FHelix System</button>
        </div>
    );
};

export default BerichtAuswertungen;
